import {faPaperclip} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {boundMethod} from "autobind-decorator";
import React from "react";
import {Link} from "react-router-dom";

import {EDocIdPrefixes, IItemSelectionState, INestedBaseItem} from "./models";

import InlineCheckbox from "@toolbox/button-like/InlineCheckbox";
import Highlighter from "@toolbox/display-blocks/Highlighter";
import {getSelection, isSelected} from "./SearchItem";
import {getDocIdInfo} from "./doc-type";

export interface IFractureSamplesProps {
    project: number;
    selection: IItemSelectionState;
    items: INestedBaseItem[] | undefined;
    query: string;

    onChange(selection: IItemSelectionState): void;
}

class FractureSamples extends React.PureComponent<IFractureSamplesProps> {
    @boundMethod
    public onSelected(checked: boolean, id: string) {
        const specimens = this.getSpecimens();
        if (!specimens) {
            return;
        }

        const changed = specimens.find((x) => id.includes(x.id));
        if (!changed) {
            return;
        }

        changed.selected = checked;
        this.props.onChange(getSelection(specimens));
    }

    public render() {
        const {query} = this.props;
        const specimens = this.getSpecimens();
        if (!specimens) {
            return null;
        }

        return specimens.map(({hasAttachment, id, name, url, selected}) => (
            <React.Fragment key={id}>
                <InlineCheckbox
                    idSuffix={id}
                    className="mb-1"
                    checked={selected}
                    toggle={this.onSelected}
                >
                    <Link to={url}>
                        <Highlighter query={query} text={name} />
                    </Link>
                    {hasAttachment && (
                        <FontAwesomeIcon
                            className="ml-2 text-muted"
                            icon={faPaperclip}
                        />
                    )}
                </InlineCheckbox>
                <br />
            </React.Fragment>
        ));
    }

    private getSpecimens() {
        const {project, selection, items} = this.props;
        const specimens = items?.filter((x) =>
            x.id.startsWith(EDocIdPrefixes.FracSamples),
        );
        if (!specimens?.length) {
            return null;
        }

        return specimens.map((x) => {
            const {url, id} = getDocIdInfo(x.id, project);
            const {hasAttachment, name} = x;

            return {
                id,
                url,
                name,
                selected: isSelected(id, selection),
                hasAttachment,
            };
        });
    }
}

export default FractureSamples;
